/* ===========================================================================
   DE KLEURENWAAIER — behaviour
   Everything here is an upgrade on markup that already works without it.
   ======================================================================== */
(function () {
  'use strict';

  function money(cents) {
    var whole = cents % 100 === 0;
    return '€' + (cents / 100).toFixed(whole ? 0 : 2).replace('.', ',');
  }

  /* The server render IS the empty state, so it only has to be captured once
     to be restorable. Kept on the node rather than in a map so it disappears
     with the node when a section is re-rendered. */
  function remember(el) {
    if (!el) return '';
    if (typeof el.__kwRest !== 'string') el.__kwRest = el.textContent;
    return el.__kwRest;
  }

  /* --- Live catalogue counts ------------------------------------------
     Counts are never typed into the theme. Each family link is asked for
     its own filtered count through a bare alternate template. ---------- */

  function resolveCounts() {
    var nodes = document.querySelectorAll('[data-kw-count]');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (node) {
      if (node.__kwDone) return;
      var href = node.getAttribute('data-kw-count');
      if (!href || href.indexOf('/collections/') !== 0) return;

      var url = href + (href.indexOf('?') === -1 ? '?' : '&') + 'view=count';

      fetch(url, { headers: { 'X-Requested-With': 'kw' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (text) {
          var n = parseInt(String(text).replace(/[^0-9]/g, ''), 10);
          if (!isFinite(n) || n <= 0) return;

          node.__kwDone = true;
          node.textContent = n + ' geuren';

          /* The rail is a data graphic: each divider is sized to its count. */
          var seg = node.closest ? node.closest('[data-kw-weight]') : null;
          if (seg) seg.style.setProperty('--w', String(n));
        })
        .catch(function () { /* the typed fallback label stays */ });
    });
  }

  /* --- Free-shipping meter ---------------------------------------------
     The bar scales on the compositor rather than animating its width, so a
     cart change never relayouts the header. An empty cart keeps the
     server-rendered sentence: restating the same fact in a different format
     is churn, not information. ------------------------------------------ */

  function paintMeter(cart) {
    var meters = document.querySelectorAll('[data-kw-meter]');
    if (!meters.length) return;

    Array.prototype.forEach.call(meters, function (meter) {
      var threshold = parseInt(meter.getAttribute('data-kw-meter'), 10);
      if (!isFinite(threshold) || threshold <= 0) return;

      var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      var remaining = Math.max(0, threshold - total);
      var ratio = Math.min(1, total / threshold);

      var fill = meter.querySelector('[data-kw-meter-fill]');
      var label = meter.querySelector('[data-kw-meter-label]');

      /* Optional, and today only the floating dock carries them: the reading
         split into its parts, so each one can be set at the size this theme
         gives every other measurement. The basket is the charge, the amount
         is what the cell still has to take. A meter without these elements
         behaves exactly as it did before. */
      var amount = meter.querySelector('[data-kw-meter-amount]');
      var caption = meter.querySelector('[data-kw-meter-caption]');
      var basket = meter.querySelector('[data-kw-meter-total]');
      var done = total > 0 && remaining === 0;

      if (fill) {
        fill.style.setProperty('--kw-meter-pct', String(ratio));
        fill.classList.toggle('is-done', done);
      }
      /* A meter that collapses while there is nothing to measure needs one
         hook CSS can reach, and the ratio lives on the fill rather than here
         — custom properties inherit downwards, so a descendant's value can
         never style its own container. A class is the cheapest way up. */
      meter.classList.toggle('is-filling', total > 0);
      /* Emptying the cart has to walk every reading back down. The old guard
         skipped writing at zero altogether, which left the last full-cart
         wording standing: "Vol" printed under a cell with nothing in it. */
      var restLabel = remember(label);
      var restAmount = remember(amount);
      var restCaption = remember(caption);

      if (label) {
        label.textContent = total === 0
          ? restLabel
          : done
            ? 'Je verzending is gratis.'
            : 'Nog ' + money(remaining) + ' tot gratis verzending.';
      }
      /* The basket prints at zero too: an instrument at rest still shows a
         value, and an empty cell is a reading rather than an absence. */
      if (basket) {
        basket.textContent = money(total);
      }
      /* At the threshold the amount stays a number rather than a word: the
         two readings are a pair, and money(0) already says "€0". Swapping one
         of them for prose breaks the tabular column they share. The caption
         carries the good news instead. */
      if (amount) {
        amount.textContent = total === 0 ? restAmount : money(remaining);
      }
      if (caption) {
        caption.textContent = total === 0 ? restCaption : (done ? 'gratis verzending' : 'te gaan');
      }
      meter.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    });
  }

  function readCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'kw' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(paintMeter)
      .catch(function () { /* meter keeps its server-rendered state */ });
  }

  /* Re-read the cart after any mutation, whoever performed it. */
  function watchCart() {
    if (!window.fetch || window.__kwCartWatched) return;
    window.__kwCartWatched = true;

    var native = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) { url = ''; }

      var result = native.apply(this, args);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(function () { readCart(); }).catch(function () {});
      }
      return result;
    };

    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (name) {
      document.addEventListener(name, readCart);
    });
  }

  /* --- One control propagates across the whole deck ---------------------
     A note or family click re-ranks the catalogue in one motion instead of
     a full page load. Plain links remain the fallback. ------------------ */

  function bindFilters() {
    var deck = document.querySelector('[data-kw-results]');
    if (!deck || deck.__kwBound) return;
    deck.__kwBound = true;

    var sectionId = deck.getAttribute('data-kw-results');

    function swap(url, push) {
      deck.setAttribute('aria-busy', 'true');

      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'kw' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-kw-results]');
          if (!next) { window.location.assign(url); return; }

          deck.innerHTML = next.innerHTML;
          deck.removeAttribute('aria-busy');
          if (push) window.history.pushState({ kw: true }, '', url);

          var heading = deck.querySelector('[data-kw-results-heading]');
          if (heading) heading.focus();
        })
        .catch(function () { window.location.assign(url); });
    }

    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var link = ev.target.closest('[data-kw-filter]');
      if (!link) return;
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;

      var href = link.getAttribute('href');
      if (!href) return;

      ev.preventDefault();
      swap(href, true);
    });

    window.addEventListener('popstate', function () {
      swap(window.location.pathname + window.location.search, false);
    });
  }

  function boot() {
    resolveCounts();
    bindFilters();
    watchCart();
    readCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
